import React, { Component } from "react";
import SurveyAnalyticsRoot from './SurveyAnalyticsRoot';

export default class SurveyAnalyticsPage extends Component {


    render() {
        return (
            <div className="aq">
                <div className="main-container">
                    <div className="nav-section">

                        <div className="nav-section-for-collapse">
                            <div className="navbar-brand">Welcome to the PCRB/DCRB
                            <br />
                            Correspondence Manager
                        </div>
                            <div></div>
                        </div>

                    </div>
                    <div className="user-home-page-content">
                        <SurveyAnalyticsRoot encryptedParam={this.props.location.search}></SurveyAnalyticsRoot>
                    </div>

                </div>
            </div>
        )
    }


}
